import { render, staticRenderFns } from "./MAM_searchResult.vue?vue&type=template&id=56857d4e&scoped=true&"
import script from "./MAM_searchResult.vue?vue&type=script&lang=js&"
export * from "./MAM_searchResult.vue?vue&type=script&lang=js&"
import style0 from "./MAM_searchResult.vue?vue&type=style&index=0&id=56857d4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56857d4e",
  null
  
)

export default component.exports